import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { UtilsService } from "../../../../auth/service/utils.service";
import { AuthenticationService } from "../../../../auth/service";
import { ICustomerAddressList } from "../../customer.interface";
import { CustomerService } from "../../customer.service";

@Component({
  selector: "app-form-edit-customer-referent",
  templateUrl: "./form-edit-customer-referent.component.html",
  styleUrls: ["./form-edit-customer-referent.component.scss"],
})
export class FormEditCustomerReferentComponent implements OnInit {
  @Output() callbackFn: EventEmitter<any> = new EventEmitter();
  @Output() onEdit: EventEmitter<any> = new EventEmitter();
  @Input() selectedReferent: any = {};
  @ViewChild("addNewReferent") addNewReferentModal: ElementRef;
  public formGroup: FormGroup;
  public addressesList: ICustomerAddressList[] = [];
  private showErrors: any = false;

  constructor(
    public _utilService: UtilsService,
    public _modalService: NgbModal,
    private _formBuilder: FormBuilder,
    public customerService: CustomerService,
    public _authenticationService: AuthenticationService,
  ) {}

  async ngOnInit() {
    this.formGroup = this._formBuilder.group({
      site: new FormControl(this.selectedReferent.addresses[0].id, [Validators.required, Validators.minLength(2), Validators.maxLength(255)]),
      client: new FormControl(this.selectedReferent.client_id, [Validators.required, Validators.minLength(2), Validators.maxLength(255)]),
      firstname: new FormControl(this.selectedReferent.firstname, [Validators.required, Validators.minLength(2), Validators.maxLength(255)]),
      lastname: new FormControl(this.selectedReferent.lastname, [Validators.required, Validators.minLength(2), Validators.maxLength(255)]),
      email: new FormControl(this.selectedReferent.email, [Validators.required, Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")]),
      phone: new FormControl(this.selectedReferent.phone),
    });
    this.filterAddresses(false);
    setTimeout(() => this.openModal());
  }

  openModal() {
    this._modalService.open(this.addNewReferentModal, {
      centered: true,
      size: "lg",
      backdrop: false,
      keyboard: false,
    });
  }

  filterAddresses(resetSite: boolean = true) {
    if (resetSite) {
      this.formGroup.patchValue({ site: null });
    }
    const clientID: number = this.formGroup.value.client;
    this.addressesList = this.customerService.addresses.filter((address: any) => {
      return address.client.id === clientID;
    });
  }

  fieldHasErrors(field_name: string): boolean {
    if (this.showErrors) {
      return this.formGroup.controls[field_name].status === "INVALID";
    } else {
      return this.formGroup.controls[field_name].status === "INVALID" && this.formGroup.controls[field_name].touched;
    }
  }

  async edit() {
    this.showErrors = true;
    // controllo valori
    if (this.formGroup.invalid) {
      return false;
    }
    this._utilService.showLoading();
    await this.customerService
      .editReferent(this.selectedReferent.id, this.formGroup.value)
      .then(async () => {
        this._utilService.hideLoading();
        this.onEdit.emit();
        await this._utilService.showSWALSuccess({ text: "SUCCESS_EDIT_CUSTOMER_REFERENT" });
      })
      .catch(async () => {
        this._utilService.hideLoading();
        await this._utilService.showSWALError({ text: "ERROR_EDIT_CUSTOMER_REFERENT" });
      });

    this.closeModal();
  }

  closeModal() {
    this._modalService.dismissAll();
    this.formGroup.reset();
    this.callbackFn.emit();
  }
}
